import {Flex, Form, Space} from "antd";
import {AddButton, Button} from "@/theme/ui";
import {useRouter} from "@/navigation";

export const formSubmitEvent = (form) =>{
    if (form.getFieldValue('isSubmitForm') && form.getFieldValue('isCancelForm')){
        form.setFieldValue('isCancelForm', false)
        form.setFieldValue('isSubmitForm', false)
    }else if (!form.getFieldValue('isSubmitForm')){
        form.setFieldValue('isSubmitForm', true)
    }
}

export const FormButton = ({isCreate, onClone, onFinish}) => {
    const route = useRouter();
    const form = Form.useFormInstance();

    const onCancel = () =>{
        const isSubmitForm = form.getFieldValue('isSubmitForm')
        form.resetFields()
        form.setFieldValue('isCancelForm', true)
        form.setFieldValue('isSubmitForm', isSubmitForm)
    }

    const disabledSubmit = () =>{
        if (form.getFieldValue('isSubmitForm') && form.getFieldValue('isCancelForm')) {
            return false
        }

        return !form.isFieldsTouched()
    }

    const disabledCancel = () =>{
        if (isCreate){
            return !form.isFieldsTouched()
        }

        if (!form.getFieldValue('isSubmitForm') && !form.getFieldValue('isCancelForm')) {
            return true
        }

        return !form.isFieldsTouched()
    }

    return (
        <>
            <Flex
                justify={'space-between'}
                align={'center'}
                style={{
                    marginTop: 24
                }}
            >
                <Button
                    type="text"
                    onClick={()=>route.back()}
                >
                    Back
                </Button>

                <Flex
                    justify={'flex-end'}
                    align={'center'}
                >
                    <Form.Item
                        noStyle
                        shouldUpdate
                    >
                        {({isFieldsTouched}) =>(
                            <Space>
                                <Button
                                    type="text"
                                    onClick={onCancel}
                                    disabled={disabledCancel()}
                                >
                                    Cancel
                                </Button>
                                {(isCreate)
                                    ? (
                                        <AddButton
                                            disabled={!isFieldsTouched()}
                                            htmlType="submit"
                                            onClick={()=>{
                                                if (onFinish){
                                                    onFinish()
                                                }
                                            }}
                                        >
                                            Create
                                        </AddButton>
                                    )
                                    : (
                                        <>
                                            <Button
                                                type={'primary'}
                                                htmlType="submit"
                                                disabled={disabledSubmit()}
                                                onClick={()=>{
                                                    if (onFinish){
                                                        onFinish()
                                                    }
                                                }}
                                            >
                                                Update
                                            </Button>
                                            {(onClone) &&  (
                                                <Button
                                                    type="dashed"
                                                    danger
                                                    onClick={onClone}
                                                    confirm
                                                >
                                                    Clone
                                                </Button>
                                            )}
                                        </>
                                    )
                                }
                            </Space>
                        )}
                    </Form.Item>
                </Flex>
            </Flex>
        </>
    );
}